import { render, staticRenderFns } from "./MessageInbox.vue?vue&type=template&id=2584a1f2&scoped=true&"
import script from "./MessageInbox.vue?vue&type=script&lang=ts&"
export * from "./MessageInbox.vue?vue&type=script&lang=ts&"
import style0 from "./MessageInbox.vue?vue&type=style&index=0&id=2584a1f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584a1f2",
  null
  
)

export default component.exports